import React, {Component} from "react";
import {Badge, Layout, Button} from "antd";
import "./index.scss";
import CustomScrollbars from "util/CustomScrollbars";
import languageData from "./languageData";
import {
    switchLanguage,
    toggleCollapsedSideNav
} from "../../appRedux/actions/Setting";
import Auxiliary from "util/Auxiliary";

import {
    NAV_STYLE_DRAWER,
    NAV_STYLE_FIXED,
    NAV_STYLE_MINI_SIDEBAR,
    TAB_SIZE
} from "../../constants/ThemeSetting";
import {connect} from "react-redux";
import Notification from "../../notification/notification";

const {Header} = Layout;

class Topbar extends Component {
    state = {
        searchText: "",
        hasNotif: false,
        state: false
    };

    languageMenu = () => (
        <CustomScrollbars className="gx-popover-lang-scroll">
            <ul className="gx-sub-popover">
                {languageData.map(language => (
                    <li
                        className="gx-media gx-pointer"
                        key={JSON.stringify(language)}
                        onClick={e => this.props.switchLanguage(language)}
                    >
                        <i
                            className={`flag flag-24 gx-ml-2 flag-${language.icon}`}
                        />
                        <span className="gx-language-text">
                            {language.name}
                        </span>
                    </li>
                ))}
            </ul>
        </CustomScrollbars>
    );

    updateSearchChatUser = evt => {
        this.setState({
            searchText: evt.target.value
        });
    };

    render() {
        const {locale, width, navCollapsed, navStyle} = this.props;
        return (
            <Auxiliary>
                <Header>
                    {navStyle === NAV_STYLE_DRAWER ||
                    ((navStyle === NAV_STYLE_FIXED ||
                        navStyle === NAV_STYLE_MINI_SIDEBAR) &&
                        width < TAB_SIZE) ? (
                        <div className="gx-linebar gx-ml-3">
                            <i
                                className="gx-icon-btn icon icon-menu"
                                onClick={() => {
                                    this.props.toggleCollapsedSideNav(
                                        !navCollapsed
                                    );
                                }}
                            />
                        </div>
                    ) : null}
                    <div className='temx-header-links'>
                        <a href='/'>صفحه اصلی</a>
                        <a href='/page/allprice'>قیمت ارز ها</a>
                        <a href='https://blog.temx.org/' target='_blank'>وبلاگ</a>
                        <a href='/page/laws'>قوانین و مقررات</a>
                        <a href='/page/FAQ'>سوالات متداول</a>
                    </div>

                    <ul className="gx-header-notifications gx-mr-auto">
                        <div
                            className="main-div"
                            onClick={() => {
                                this.setState({
                                    state: true,
                                    notif: false
                                });
                                //  setState(true);
                                localStorage.setItem("hasNotif", false);
                                //  setHasNotif(false);
                            }}
                        >
                            <Badge
                                dot
                                style={{
                                    display: this.state.hasNotif
                                        ? "block"
                                        : "none",
                                    position: "absolute",
                                    left: "5px",
                                    width: "10px",
                                    height: "10px"
                                }}
                            >
                                <i
                                    style={{
                                        color: "#EEBD4E",
                                        fontSize: "25px",
                                        cursor: "pointer"
                                    }}
                                    className="far fa-bell"
                                />
                            </Badge>
                            <div className="notif-component">
                                {this.state.state && (
                                    <i className="fas fa-caret-up top-triangle"/>
                                )}
                                <div className="box">
                                    <Notification
                                        close={() => {
                                            this.setState({
                                                state: false
                                            });
                                        }}
                                        status={this.state.state}
                                    />
                                </div>
                            </div>
                        </div>
                    </ul>
                </Header>
            </Auxiliary>
        );
    }
}

const mapStateToProps = ({settings}) => {
    const {locale, navStyle, navCollapsed, width} = settings;
    return {locale, navStyle, navCollapsed, width};
};

export default connect(mapStateToProps, {
    toggleCollapsedSideNav,
    switchLanguage
})(Topbar);
